import RequestError from 'client/services/response/RequestError';

const webAuthnError = new RequestError(0, 'Failed to verify security key.');
const webAuthnUnsupportedError = new RequestError(0, 'This browser does not support Security Keys.');

export {
  webAuthnError,
  webAuthnUnsupportedError,
};
